// import { createRouter ,createWebHashHistory } from 'vue-router'
// // import HomeView from '../views/HomeView.vue'
// import LayoutsView from '../views/LayoutsView.vue'
// import LoginView from '../views/LoginView.vue'

// const router = createRouter({
//   history: createWebHashHistory(import.meta.env.BASE_URL),
//   routes: [
//     {
//       path: '/',
//       name: 'home',
//       component: LayoutsView,
//     },
//     {
//       path: '/login',
//       name: 'login',
//       // route level code-splitting
//       // this generates a separate chunk (About.[hash].js) for this route
//       // which is lazy-loaded when the route is visited.
//       // component: () => import('../views/AboutView.vue'),
//       component: LoginView,
//     },
//   ],
// })

// export default router

import { createRouter, createWebHashHistory } from 'vue-router'

// @ts-ignore
import routes from '~pages'

// console.log('路由', routes)

// 3. 创建路由实例并传递 `routes` 配置
// 你可以在这里输入更多的配置，但我们在这里
// 暂时保持简单
console.log(routes)
const router = createRouter({
  // 4. 内部提供了 history 模式的实现。为了简单起见，我们在这里使用 hash 模式。
  history: createWebHashHistory(import.meta.env.BASE_URL),
  // @ts - ignore
  routes, // `routes: routes` 的缩写
})

export default router
